import React, { useEffect, useState } from 'react';
import StaticLayout from '../../layouts/StaticLayout';
import { Loader } from '../../components/Loader';
import { useSearchParams } from 'react-router-dom';

export default function Unsubscribe() {
	const [isLoading, setIsLoading] = useState(true);
	const [isSuccess, setIsSuccess] = useState(false);
	const [error, setError] = useState(null);

	const [searchParams, setSearchParams] = useSearchParams();

	const type = searchParams.get('type');
	const userId = searchParams.get('userId');
	const hash = searchParams.get('hash');

	const fetchUnsubscribe = async () => {
		setIsLoading(true);
		setIsSuccess(false);
		setError(null);

		try {
			const response = await fetch(`${process.env.REACT_APP_API_URL}/email/unsubscribe`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ type, userId, hash }),
			});
			const data = await response.json();

			if (response.status === 200) {
				setIsSuccess(true);
				setError(null);
			} else {
				setError(data.message);
			}
		} catch (error) {
			console.error('Error submitting form:', error);
			setError('An error occurred, please try again later.');
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		fetchUnsubscribe();
	}, []);

	return (
		<StaticLayout size={'big'} layoutCenter layoutFixed>
			<div className="basis-0 grow shrink">
				{isLoading && (
					<div className="text-brand-green w-[50px] h-[50px] my-1 mx-auto">
						<Loader />
					</div>
				)}
				{isSuccess && (
					<h1 className="h2 text-center font-semibold text-brand-green mt-2 mb-[22px] md:mb-8 font-founders tracking-normal leading-none md:text-center max-w-[29rem] md:max-w-[35rem] mx-auto">
						You were unsubscribed from Weekly Reports successfully.
					</h1>
				)}
				{error && (
					<h1 className="h2 text-center font-semibold text-brand-green mt-2 mb-[22px] md:mb-8 font-founders tracking-normal leading-none md:text-center max-w-[29rem] md:max-w-[35rem] mx-auto">
						{error}
					</h1>
				)}
			</div>
		</StaticLayout>
	);
}
